import React from 'react';
import { motion } from 'framer-motion';
import { XIcon, AlertTriangleIcon } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-24 px-6 bg-[#0A0A0A] relative" data-id="element-358">
      <div className="max-w-5xl mx-auto" data-id="element-359">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-360">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#E8E0D0] mb-6 leading-tight" data-id="element-361">
            Simplifica Tu Vida con IA: <br className="hidden md:block" data-id="element-362" />
            <span className="text-[#D4AF37] italic" data-id="element-363">
              Domina la IA y Recupera Horas Libres Cada Día
            </span>
          </h2>
          <p className="text-xl text-[#A09880] max-w-3xl mx-auto font-medium" data-id="element-364">
            La guía práctica para resolver problemas, automatizar tareas y
            optimizar tu rutina en minutos
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-[#111111] border border-[#D4AF37]/20 rounded-2xl p-8 md:p-10 mb-16 text-center shadow-[0_0_30px_rgba(212,175,55,0.05)]" data-id="element-365">
          <p className="text-lg md:text-xl text-[#E8E0D0] leading-relaxed" data-id="element-366">
            Imagina poder resolver tus pendientes diarios en minutos, sin estrés
            ni pérdida de tiempo. Ahora, con solo unos prompts precisos, puedes
            automatizar tus tareas, lograr orden y recuperar horas libres para
            lo que realmente importa.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-367">
          {/* Problem Card */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-[#111111] border border-[#FF3B3B]/20 rounded-2xl p-8 relative overflow-hidden" data-id="element-368">
            <div className="absolute top-0 right-0 w-32 h-32 bg-[#FF3B3B]/5 blur-[60px] rounded-full" data-id="element-369"></div>
            <div className="flex items-center gap-3 mb-6" data-id="element-370">
              <div className="bg-[#FF3B3B]/10 p-2 rounded-lg" data-id="element-371">
                <XIcon className="w-6 h-6 text-[#FF3B3B]" data-id="element-372" />
              </div>
              <h3 className="text-xl font-bold text-[#FF3B3B]" data-id="element-373">
                El Problema Real
              </h3>
            </div>
            <p className="text-[#A09880] mb-6 font-medium" data-id="element-374">
              Cada día te enfrentas a un sinfín de tareas:
            </p>
            <ul className="space-y-4" data-id="element-375">
              {['Organizar tu agenda te consume tiempo.', 'Redactar correos profesionales se vuelve pesado.', 'Generar contenido creativo es un reto constante.', 'Y al final del día, sientes que no avanzas lo suficiente.'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-376">
                  <span className="text-[#FF3B3B] mt-1" data-id="element-377">→</span>
                  <span className="text-[#E8E0D0]" data-id="element-378">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Failed Solutions Card */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-[#111111] border border-[#D4AF37]/20 rounded-2xl p-8 relative overflow-hidden" data-id="element-379">
            <div className="absolute top-0 right-0 w-32 h-32 bg-[#D4AF37]/5 blur-[60px] rounded-full" data-id="element-380"></div>
            <div className="flex items-center gap-3 mb-6" data-id="element-381">
              <div className="bg-[#D4AF37]/10 p-2 rounded-lg" data-id="element-382">
                <AlertTriangleIcon className="w-6 h-6 text-[#D4AF37]" data-id="element-383" />
              </div>
              <h3 className="text-xl font-bold text-[#D4AF37]" data-id="element-384">
                Por qué falló lo anterior
              </h3>
            </div>
            <ul className="space-y-4 mt-12" data-id="element-385">
              {['Las agendas tradicionales no se adaptan a tu ritmo.', 'Las apps de productividad son genéricas y complejas.', 'Perder horas buscando ideas o redactando propuestas es agotador.', 'Cursos largos de organización tardan semanas en aplicarse.'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-386">
                  <span className="text-[#D4AF37] mt-1" data-id="element-387">–</span>
                  <span className="text-[#E8E0D0]" data-id="element-388">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}